/* eslint-disable max-len */
import { ExportSquare } from 'iconsax-react';
import { Link } from 'react-router-dom';
import facebook from '../../../../assets/images/facebook.svg';
import instagram from '../../../../assets/images/instagram.svg';
import outher from '../../../../assets/images/outher.svg';
import twitter from '../../../../assets/images/twitter.svg';
import Center from '../../../../assets/styles/Center';
import Text from '../../../../assets/styles/Text';
import { useSettings } from '../../../../hooks/queries/useSettings';
import Error from '../../../Error';
import Loader from '../../../Loader';
import * as styles from './styles';

export default function Top() {
  const { data: settings, isLoading, isError, error } = useSettings();

  const listLinks1 = [
    { text: 'Login Modelo', url: '/modellogin', id: 1 },
    { text: 'Cadastro Modelo', url: '/modelregister', id: 2 },
    { text: 'Login Cliente', url: '/clientlogin', id: 3 },
    { text: 'Cadastro Cliente', url: '/clientregister', id: 4 },
  ];

  const listLinks2 = [
    { text: 'Termos de uso', url: '/term', id: 3 },
    { text: 'Politicas de privacidade', url: '/policies', id: 4 },
  ];

  if (isLoading) return <Loader isLoading={isLoading} />;

  if (isError) {
    return <Error error message={error?.message} />;
  }

  return (
    <styles.Top>
      <Center>
        <styles.GroupAbout>
          <Text.H2>Sobre a Flame Hot</Text.H2>
          <Text.P>
            A FlameHot é uma vitrine online de acompanhantes, focada nas regiões
            de São Paulo, Paraná, Santa Catarina e Rio Grande do Sul. Nossa
            plataforma oferece praticidade, sigilo e confiança para quem busca
            visibilidade com discrição.
          </Text.P>

          <div className="links">
            {settings.facebook && (
              <a href={settings.facebook} target="blank">
                <img src={facebook} alt="icone" />
              </a>
            )}

            {settings.twitter && (
              <a href={settings.twitter} target="blank">
                <img src={twitter} alt="icone" />
              </a>
            )}

            {settings.instagram && (
              <a href={settings.instagram} target="blank">
                <img src={instagram} alt="icone" />
              </a>
            )}

            {settings.outher && (
              <a href={settings.outher} target="blank">
                <img src={outher} alt="icone" />
              </a>
            )}
          </div>
        </styles.GroupAbout>

        <styles.GroupNav className="desktop">
          {listLinks1.map((link) => (
            <Link to={link.url} key={link.id}>
              <ExportSquare />
              {link.text}
            </Link>
          ))}
        </styles.GroupNav>

        <styles.GroupNav className="desktop">
          {listLinks2.map((link) => (
            <Link to={link.url} key={link.id}>
              <ExportSquare />
              {link.text}
            </Link>
          ))}

          <Link to="/plans" className="link">
            <Text.P>Conheça nossos planos</Text.P>
          </Link>

          <Text.Span>
            <b>Fale Conosco:</b> suporte.flamehot@
            <wbr />
            gmail.com
          </Text.Span>
        </styles.GroupNav>

        <div className="mobile">
          <styles.GroupNav>
            {listLinks1.map((link) => (
              <Link to={link.url} key={link.id}>
                <ExportSquare />
                {link.text}
              </Link>
            ))}
          </styles.GroupNav>

          <styles.GroupNav>
            {listLinks2.map((link) => (
              <Link to={link.url} key={link.id}>
                <ExportSquare />
                {link.text}
              </Link>
            ))}
          </styles.GroupNav>
        </div>

        <div className="mobile">
          <styles.GroupNav>
            <Link to="/plans" className="link">
              <Text.P>Conheça nossos planos</Text.P>
            </Link>

            <Text.Span>
              <b>Fale Conosco:</b> suporte.flamehot@
              <wbr />
              gmail.com
            </Text.Span>
          </styles.GroupNav>
        </div>
      </Center>
    </styles.Top>
  );
}
